import React from "react";
import "./portfolio.css";

const data = [
  {
    id: 1,
    image: require("../../assets/saarathi.png"),
    title: "Saarathi Mobile App -ios & android",
    github: "https://github.com",
    demo: "https://play.google.com/store/apps/details?id=dataon.decimal.saarathi.mars&hl=en_IN&gl=US",
  },
  {
    id: 2,
    image: require("../../assets/saarathi.png"),
    title: "Vahana Mobile App",
    github: "https://github.com",
    demo: "https://decimaltech.com/vahana-cloud-platform/#",
  },
  {
    id: 3,
    image: require("../../assets/episode.webp"),
    title: "EnavPatient Mobile App",
    github: "https://github.com",
    demo: "https://play.google.com/store/apps/details?id=com.episodesolutions.enavpatient&hl=en_IN&gl=US",
  },
  {
    id: 4,
    image: require("../../assets/episode.webp"),
    title: "ENavProvider Mobile App",
    github: "https://github.com",
    demo: "https://play.google.com/store/apps/details?id=com.episodesolutions.enavprovider&hl=en_IN&gl=US",
  },
  {
    id: 5,
    image: require("../../assets/medidata.jpeg"),
    title: "Medidata Web App",
    github: "https://github.com",
    demo: "https://www.medidata.com/en/",
  },
];

const Portfolio = () => {
  return (
    <section id="portfolio">
      <h5>My Recent Work</h5>
      <h2>Portfolio</h2>

      <div className="container portfolio__container">
        {data.map(({ id, image, title, github, demo }) => (
          <article className="portfolio__item">
            <div className="portfolio__item-image">
              <img src={image} alt={title} className="portfolio__img"></img>
            </div>
            <h3>{title}</h3>
            <div className="portfolio__item-cta">
              <a href={github} className="btn">
                Github
              </a>
              <a href={demo} className="btn btn-primary">
                Live Demo
              </a>
            </div>
          </article>
        ))}
      </div>
    </section>
  );
};

export default Portfolio;
